import {
  post_request,
  get_request_export
} from '../axiosFun'

//查询调度计划列表
export const get_dispatch_list = (params) => {
  params = {
    row: {
      plan_name: params.plan_name,
      creator: params.creator,
      create_date: params.create_date,
      head: params.head,
      plan_status: params.plan_status,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/schedule/list", params)
}
//添加   计划负责人列表
export const get_planHead_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/schedule/user_list", params)
}
//添加调度计划
export const get_dispatch_add = (params) => {
  params = {
    row: {
      planName: params.planName,
      head: params.head,
      startTimeStr: params.time_upend[0],
      endTimeStr: params.time_upend[1],
    }
  }
  return post_request("/web/schedule/add", params)
}
  //获取单条调度计划
  export const get_dispatch_one = (params) => {
    params = {
      row: {
        id:params
      }
    }
    return post_request("/web/schedule/get_one", params)
  }
  //编辑调度计划
  export const get_dispatch_edit = (params) => {
    params = {
      row: {
        id:params.id,
        planName: params.planName,
        head: params.head,
        startTimeStr: params.time_upend[0],
        endTimeStr: params.time_upend[1],
      }
    }
    return post_request("/web/schedule/update", params)
  }
   //删除调度计划
   export const get_dispatch_del = (params) => {
    params = {
      row: {
        id:params
      }
    }
    return post_request("/web/schedule/delete", params)
  }



// WEBPACK FOOTER //
// ./src/api/dispatch/dispatch.js